class UASwymWishlist {
  static swymCallbackFn(swat) {
    document.addEventListener('swym:refresh-products', (event) => {
      const elementSelector = event.detail.selector;
      swat.initializeActionButtons(elementSelector);
      swymCustomFunctions.init(swat);
    });

    document.addEventListener('swym:refresh-buttons', evt => {
      // swat.initializeActionButtons('body');
      // document.querySelectorAll('.swym-hide-wishlist-dummy-btn').forEach(btn => btn.classList.remove('swym-hide-wishlist-dummy-btn'))
      document.dispatchEvent(new CustomEvent('swym:refresh-cart-drawer-btns'));
    })
  }

  static initializeSwymCallbacks() {
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }

    window.SwymCallbacks.push(UASwymWishlist.swymCallbackFn);
  }
}

UASwymWishlist.initializeSwymCallbacks();